import { IconButton, Box } from '@mui/material';
import Iconify from 'src/components/iconify';
import { RHFAutocomplete } from '../hook-form';

const DropDownAddValueShowDetailsCustom = ({
  name,
  label,
  options = [],
  onChange,
  addValue,
  showDetails,
  disableDetails,
}) => {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'start' }}>
        <RHFAutocomplete
          sx={{ width: '100%' }}
          name={name}
          label={label}
          options={options}
          getOptionLabel={(option) => option?.name || ''}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          onChange={onChange}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          )}
        />
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            addValue();
          }}
          className="cardColor"
          sx={{
            margin: '5px 10px',

            color: '#FFF',
            fontSize: 25,
            padding: '7px',
            borderRadius: '50%',
            '&:hover': {
              backgroundColor: '#7AB13A',
            },
            boxShadow: '0 3px 5px rgba(0, 0, 0, 0.2)',
          }}
        >
          <Iconify icon="mingcute:add-line" />
        </IconButton>
        <IconButton
          disabled={disableDetails}
          onClick={(e) => {
            e.stopPropagation();
            showDetails();
          }}
          className="cardColor"
          sx={{
            margin: '5px 0px',

            color: '#FFF',
            fontSize: 25,
            padding: '7px',
            borderRadius: '50%',
            '&:hover': {
              backgroundColor: '#7AB13A',
            },
            boxShadow: '0 3px 5px rgba(0, 0, 0, 0.2)',
          }}
        >
          <Iconify icon="mynaui:info" />
        </IconButton>
      </Box>
    </>
  );
};

export default DropDownAddValueShowDetailsCustom;
